module.exports = {"610723001":"洋州街道","610723002":"纸坊街道","610723003":"戚氏街道","610723103":"龙亭镇","610723104":"谢村镇","610723105":"马畅镇","610723107":"溢水镇","610723108":"磨子桥镇","610723109":"黄家营镇","610723110":"黄安镇","610723111":"黄金峡镇","610723112":"槐树关镇","610723113":"金水镇","610723114":"华阳镇","610723115":"茅坪镇","610723119":"八里关镇","610723120":"桑溪镇","610723121":"关帝镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610723.json
// module id = 2851
// module chunks = 0